import { UsersPreferenceData } from 'src/store/interface';
import { mixpanelObject } from 'src/utils/analytics';
import { settingsPropertySetter } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import {
  CONTENT_LANGUAGES_COOKIE,
  DISPLAY_LANGUAGE_COOKIE
} from 'src/utils/constants/cookieConstants';
import {
  getInitialDisplayLanguage,
  getInitialContentLanguage
} from 'src/utils/LanguageUtils';

import {
  setCookie,
  getLocalStorage,
  getObjectFromLocalStorage,
  setLocalStorage,
  getCookie
} from '../../../utils/browserStorageHandler';
import { SETTINGS } from '../../../utils/constants/localStorageConstants';
import { SingleLaunchResponse } from '../../responseTypes/singleLaunchResponse';

export const setGuestUserSettings = (
  locale: string,
  initialLaunchData: SingleLaunchResponse,
  isRequestedByBot?: boolean | undefined
) => {
  let displayLanguage = locale;
  let contentLanguages = getCookie(CONTENT_LANGUAGES_COOKIE) || '';
  const autoPlay = '';
  let recentSearch = '';

  if (getLocalStorage(SETTINGS) && getObjectFromLocalStorage(SETTINGS)) {
    const userSettings = getObjectFromLocalStorage(SETTINGS);
    if (!displayLanguage) {
      displayLanguage = userSettings.display_language;
    }
    if (!contentLanguages) {
      contentLanguages = userSettings.content_language;
    }
    if (!recentSearch) {
      recentSearch = userSettings.recent_search;
    }
  }

  if (!displayLanguage) {
    displayLanguage = getInitialDisplayLanguage(initialLaunchData);
  }
  if (!contentLanguages) {
    contentLanguages = getInitialContentLanguage(initialLaunchData);
  }

  if (isRequestedByBot) {
    contentLanguages = 'hi, en, mr, te, kn, ta, ml, bn, gu, pa, hr, or';
  }
  const fallbackContentLanguage = locale === 'en' ? 'en,hi' : 'en,' + locale;
  let guestUserSettings: UsersPreferenceData = {
    auto_play: autoPlay || true,
    display_language: displayLanguage || 'en',
    content_language: contentLanguages || fallbackContentLanguage,
    download_over_wifi: '',
    download_quality: '',
    first_time_login: '',
    gdpr_policy: [],
    parental_control: {},
    parental_control_v2: '',
    popups: [],
    recent_search: recentSearch || '',
    stream_over_wifi: '',
    streaming_quality: 'Auto'
  };

  if (!getLocalStorage(SETTINGS) && getObjectFromLocalStorage(SETTINGS)) {
    guestUserSettings = {
      ...guestUserSettings,
      ...getObjectFromLocalStorage(SETTINGS)
    };
  }

  //setting the cookies
  setCookie(DISPLAY_LANGUAGE_COOKIE, displayLanguage);
  setCookie(CONTENT_LANGUAGES_COOKIE, contentLanguages);

  setLocalStorage(SETTINGS, guestUserSettings);

  //mixpanel events
  settingsPropertySetter(mixpanelObject, guestUserSettings);
};
